var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
export function calculateFlexInfo(items, rowWeight, flexGap) {
  var e_1, _a;
  var currentRowWeight = 0; // Tracks the cumulative weight of the current row
  // this algorithm still needs improvement
  // one scenario which may not quite work is when we have a 1 block item then a 2 block in a 2 block row. The 1 block won't correctly stretch to the 
  // end of the row because flex will move the 2 block to the next row, but this algo will not.
  var itemsWithLast = items.map(function (item, index) {
    // Add this item's weight to the current row
    currentRowWeight += item.weight || 1;
    var isLastInRow = false;
    var effectiveWeight = item.weight;
    // Check if this is the last item that can fit on this row
    if (currentRowWeight >= rowWeight) {
      isLastInRow = true;
      effectiveWeight = currentRowWeight > rowWeight ? item.weight - (currentRowWeight - rowWeight) : item.weight;
      // Reset for the next row
      currentRowWeight = currentRowWeight > rowWeight ? currentRowWeight - rowWeight : 0;
    }
    return __assign(__assign({}, item), {
      flexInfo: {
        effectiveWeight: effectiveWeight,
        isLastInRow: isLastInRow
      }
    });
  });
  var count = 0; // Count items in the current row
  var itemsInCurrentRow = []; // Temporary storage for items in the current row
  var withItemsInRow = []; // Final result array
  try {
    for (var itemsWithLast_1 = __values(itemsWithLast), itemsWithLast_1_1 = itemsWithLast_1.next(); !itemsWithLast_1_1.done; itemsWithLast_1_1 = itemsWithLast_1.next()) {
      var item = itemsWithLast_1_1.value;
      count++;
      itemsInCurrentRow.push(item);
      if (item.flexInfo.isLastInRow) {
        // Add `itemsInRow` to all items in the current row
        itemsInCurrentRow.forEach(function (rowItem) {
          withItemsInRow.push(__assign(__assign({}, rowItem), {
            flexInfo: __assign(__assign({}, rowItem.flexInfo), {
              itemsInRow: count
            })
          }));
        });
        // Reset for the next row
        count = 0;
        itemsInCurrentRow = [];
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (itemsWithLast_1_1 && !itemsWithLast_1_1.done && (_a = itemsWithLast_1.return)) _a.call(itemsWithLast_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
  // now look over these again, and calculate the flex-basis
  for (var i = 0; i < withItemsInRow.length; i++) {
    var item = withItemsInRow[i];
    var flexInfo = item.flexInfo;
    // Derive flex-basis for this item
    var flexGapReduction = (flexInfo.itemsInRow - 1) / flexInfo.itemsInRow * flexGap;
    var basis = "calc(".concat(flexInfo.effectiveWeight / rowWeight * 100, "% - ").concat(flexGapReduction, "px)");
    itemsWithLast[i].flexInfo.basis = basis;
  }
  return itemsWithLast;
}
;